import namespace from '../../config/Namespace';

const types = {
  actions: {
    resetList: 'resetList',
    setColumns: 'setColumns',
    setColumnVisibility: 'setColumnVisibility',
    setFilters: 'setFilters',
    fetchMerchantsList: 'fetchMerchantsList',
    fetchMerchantsAllSuccess: 'fetchMerchantsAllSuccess',
    fetchMerchantDetailsSuccess: 'fetchMerchantDetailsSuccess',
    fetchMerchantSettingsFieldsData: 'fetchMerchantSettingsFieldsData',
    updateMerchantCashoutLimit: 'updateMerchantCashoutLimit',
    fetchCountriesCurrencyData: 'fetchCountriesCurrencyData',
    fetchMerchantPossibleCurrencies: 'fetchMerchantPossibleCurrencies',
  },
};

export default namespace('Merchants', types);
